







import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  components: {}
})
class JobEmploymentPositionResourceItem1JobPositionDescription extends Vue {

}

export default JobEmploymentPositionResourceItem1JobPositionDescription


